import { APAC_REGION_ID, EMEA_REGION_ID, LATM_REGION_ID } from '@/creditflowresearch/domain/Region/constants';
import { MarketName, MarketAbbreviations } from './types/MarketType';

export const US_MARKET_ID = '3dd7212e-e02c-5eab-95a9-79140d663e72' as const;
export const EUROPEAN_MARKET_ID = 'a30ebd00-ea75-5219-b75b-6f8b58f10da9' as const;
export const APAC_MARKET_ID = 'fb0b648e-3917-5a12-a1a5-f7f311f633af' as const;
export const EMERGING_MARKET_ID = '5a7f2b23-2339-5ce2-b227-ee8577a13632' as const;

export const EM_LINKED_REGION_IDS: string[] = [APAC_REGION_ID, EMEA_REGION_ID, LATM_REGION_ID];

export const MarketIdByName: Record<MarketName, string> = {
  [MarketName.US_MARKET]: US_MARKET_ID,
  [MarketName.EUROPEAN_MARKET]: EUROPEAN_MARKET_ID,
  [MarketName.APAC_MARKET]: APAC_MARKET_ID,
  [MarketName.EMERGING_MARKET]: EMERGING_MARKET_ID,
} as const;

export const MarketIdByAbbreviation: Record<MarketAbbreviations, string> = {
  [MarketAbbreviations.US_MARKET]: US_MARKET_ID,
  [MarketAbbreviations.EUROPEAN_MARKET]: EUROPEAN_MARKET_ID,
  [MarketAbbreviations.APAC_MARKET]: APAC_MARKET_ID,
  [MarketAbbreviations.EMERGING_MARKET]: EMERGING_MARKET_ID,
} as const;

export const MarketAbbreviationById: Record<string, MarketAbbreviations> = {
  [US_MARKET_ID]: MarketAbbreviations.US_MARKET,
  [EUROPEAN_MARKET_ID]: MarketAbbreviations.EUROPEAN_MARKET,
  [APAC_MARKET_ID]: MarketAbbreviations.APAC_MARKET,
  [EMERGING_MARKET_ID]: MarketAbbreviations.EMERGING_MARKET,
} as const;

export const MarketIdToNameMap: Record<string, MarketName> = {
  [US_MARKET_ID]: MarketName.US_MARKET,
  [EUROPEAN_MARKET_ID]: MarketName.EUROPEAN_MARKET,
  [APAC_MARKET_ID]: MarketName.APAC_MARKET,
  [EMERGING_MARKET_ID]: MarketName.EMERGING_MARKET,
} as const;

export const MarketAbbreviationToNameMap: Record<string, MarketName> = {
  [MarketAbbreviations.US_MARKET]: MarketName.US_MARKET,
  [MarketAbbreviations.EUROPEAN_MARKET]: MarketName.EUROPEAN_MARKET,
  [MarketAbbreviations.APAC_MARKET]: MarketName.APAC_MARKET,
  [MarketAbbreviations.EMERGING_MARKET]: MarketName.EMERGING_MARKET,
} as const;
